import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Dashboard = () => import('@/components/Dashboard.vue')
const AccountLogin = () => import('@/components/account_components/AccountLogin.vue')
const AccountCreate = () => import('@/components/account_components/AccountCreate.vue')
const AccountLogout = () => import('@/components/account_components/AccountLogout.vue')
const AccountValidate = () => import('@/components/account_components/AccountValidate.vue')
const MemberListing = () => import('@/components/menu_components/MemberListing.vue')
const MemberPage = () => import('@/components/menu_components/MemberPage.vue')
const CompanyListing = () => import('@/components/menu_components/CompanyListing.vue')
const CompanyPage = () => import('@/components/menu_components/CompanyPage.vue')
const ProjectListing = () => import('@/components/menu_components/ProjectListing.vue')
const ProjectPage = () => import('@/components/menu_components/ProjectPage.vue')
const StatusListing = () => import('@/components/menu_components/StatusListing.vue')
const StatusPage = () => import('@/components/menu_components/StatusPage.vue')
const SprintListing = () => import('@/components/menu_components/SprintListing.vue')
const SprintPage = () => import('@/components/menu_components/SprintPage.vue')
const CardTypeListing = () => import('@/components/menu_components/CardTypeListing.vue')
const CardTypePage = () => import('@/components/menu_components/CardTypePage.vue')
const CardListing = () => import('@/components/menu_components/CardListing.vue')
const CardPage = () => import('@/components/menu_components/CardPage.vue')
const ProcessFlowListing = () => import('@/components/menu_components/ProcessFlowListing.vue')
const ProcessFlowPage = () => import('@/components/menu_components/ProcessFlowPage.vue')
const EditBoard = () => import('@/components/board_components/EditBoard.vue')
const Board = () => import('@/components/board_components/Board.vue')
const Blank = () => import('@/components/Blank.vue')


export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: "Home",
            component: Dashboard,
        },
        {
            path: '/home',
            name: "Dashboard",
            component: Dashboard,
        },
        {
            path: '/account/logout',
            name: "AccountLogout",
            components: {
                default: Blank,
                other: AccountLogout
            }
        },
        {
            path: '/account/validate',
            name: "AccountValidate",
            components: {
                default: Blank,
                other: AccountValidate
            }
        },
        {
            path: '/account/login',
            name: "Login",
            components: {
                default: Blank,
                other: AccountLogin
            }
        },
        {
            path: '/account/create',
            name: "CreateAccount",
            components: {
                default: Blank,
                other: AccountCreate
            }
        },
        {
            path: '/member-list',
            name: 'Members',
            children: [
                {
                    path: ':id',
                    component: MemberPage
                }
            ],
            components: {
                default: MemberListing,
                other: Blank
            }
        },
        {
            path: '/companies',
            name: 'Companies',
            children: [
                {
                    path: ':id',
                    component: CompanyPage
                }
            ],
            components: {
                default: CompanyListing,
                other: Blank
            },
            meta: {
                title: 'Companies'
            }
        },
        {
            path: '/projects',
            name: 'ProjectListing',
            children: [
                {
                    path: ':id',
                    component: ProjectPage
                }
            ],
            components: {
                default: ProjectListing,
                other: Blank
            },
            meta: {
                title: 'Projects'
            }
        },
        {
            path: '/status-list',
            name: 'StatusListing',
            children: [
                {
                    path: ':id',
                    component: StatusPage
                }
            ],
            components: {
                default: StatusListing,
                other: Blank
            },
            meta: {
                title: 'Statuses'
            }
        },
        {
            path: '/sprint-list',
            name: 'Sprints',
            children: [
                {
                    path: ':id',
                    component: SprintPage
                }
            ],
            components: {
                default: SprintListing,
                other: Blank
            },
            meta: {
                title: 'Sprints'
            }
        },
        {
            path: '/cardtype-list',
            name: 'Cardtype',
            children: [
                {
                    path: ':id',
                    component: CardTypePage
                }
            ],
            components: {
                default: CardTypeListing,
                other: Blank
            },
            meta: {
                title: 'Cardtype'
            }
        },
        {
            path: '/card-list',
            name: 'Cards',
            children: [
                {
                    path: ':cid',
                    component: CardPage
                }
            ],
            components: {
                default: CardListing,
                other: Blank
            },
            meta: {
                title: 'Cards'
            }
        },
        {
            path: '/process-list',
            name: 'ProcessFlows',
            children: [
                {
                    path: ':id',
                    component: ProcessFlowPage
                }
            ],
            components: {
                default: ProcessFlowListing,
                other: Blank
            },
            meta: {
                title: 'ProcessFlows'
            }
        },
        {
            path: '/board',
            name: 'EditBoard',
            children: [
                {
                    path: ':id',
                    component: EditBoard
                }
            ],
            components: {
                default: EditBoard,
                other: Blank
            }
        },
        {
            path: '/boards/:id',
            name: 'Board',
            children: [
                {
                    path: 'cards/:cid',
                    component: CardPage
                }
            ],
            components: {
                default: Board,
                other: Blank
            }
        }
    ]
})